import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { Toaster } from 'sonner';

import { SuperAdminProvider } from './contexts/SuperAdminContext';
import { TenantProvider } from './contexts/TenantContext';
import { AuthProvider } from './contexts/AuthContext';
import { LoadingProvider } from './contexts/LoadingContext';

import SuperAdminLogin from './pages/SuperAdminLogin';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import Login from './pages/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Guias from './pages/Guias';
import Viagens from './pages/Viagens';
import Reservas from './pages/Reservas';
import Encomendas from './pages/Encomendas';
import Bagagens from './pages/Bagagens';
import Relatorios from './pages/Relatorios';
import Usuarios from './pages/Usuarios';
import LeitoreQRCode from './pages/LeitoreQRCode';
import AccessDenied from './pages/AccessDenied';

function TenantRoutes() {
  return (
    <TenantProvider>
      <AuthProvider>
        <LoadingProvider>
        <Routes>
          <Route path="login" element={<Login />} />
          <Route element={<Layout />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="clientes" element={<Clientes />} />
            <Route path="guias" element={<Guias />} />
            <Route path="viagens" element={<Viagens />} />
            <Route path="reservas" element={<Reservas />} />
            <Route path="encomendas" element={<Encomendas />} />
            <Route path="bagagens" element={<Bagagens />} />
            <Route path="relatorios" element={<Relatorios />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="leitor-qr" element={<LeitoreQRCode />} />
            <Route path="acesso-negado" element={<AccessDenied />} />
            <Route index element={<Navigate to="dashboard" replace />} />
          </Route>
        </Routes>
        </LoadingProvider>
      </AuthProvider>
    </TenantProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
      <SuperAdminProvider>
        <Routes>
          <Route path="/superadmin/login" element={<SuperAdminLogin />} />
          <Route path="/superadmin/dashboard" element={<SuperAdminDashboard />} />
          <Route path="/superadmin" element={<Navigate to="/superadmin/dashboard" replace />} />
          <Route path="/:tenantSlug/*" element={<TenantRoutes />} />
          <Route path="/" element={<Navigate to="/superadmin/login" replace />} />
        </Routes>
      </SuperAdminProvider>
    </BrowserRouter>
  );
}
